// Extensie is verplicht: package.json staat op "type": "module", dus .js-bestanden
// worden als strikte ESM behandeld.
import { collection } from 'firebase/firestore';
import { db } from '../firebase.js';

/**
 * Blessures en schorsingen van één seizoen.
 *
 * Wordt weggeschreven door de automatische taak `sidelinedSync`
 * (functions/index.js) in `seasons/{seasonId}/sidelined`. Het document-id is het
 * Sportmonks-sidelined-id; ieder record is gekoppeld aan een speler via het veld
 * `playerId` (een number, gelijk aan het speler-document-id).
 *
 * @param {string|number} seasonId
 */
export function seasonSidelinedCollection(seasonId) {
    return collection(db, 'seasons', String(seasonId), 'sidelined');
}
